import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';
import { galleryProjects, galleryHref } from '../../data/projects';
import './GalleryLink.css';

// "View our project gallery" - on a product page, a link to /gallery: filtered
// to this product's projects when it has any, otherwise all of them. Renders
// nothing until there is at least one project to show.
export default function GalleryLink({ productSlug, className = '' }) {
  const settings = useSettings();
  const all = galleryProjects(settings);
  if (!all.length) return null;
  const own = all.filter((p) => p.product === productSlug).length;
  const note = own
    ? `${own} ${own === 1 ? 'project' : 'projects'} with this awning, ${all.length} in all`
    : `${all.length} past ${all.length === 1 ? 'project' : 'projects'}`;
  return (
    <Link to={galleryHref(settings, productSlug)} className={`gallery-link ${className}`.trim()}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
      <span className="gallery-link-text">
        <span className="gallery-link-title">View our project gallery</span>
        <span className="gallery-link-note">{note}</span>
      </span>
      <span className="gallery-link-arrow" aria-hidden="true">→</span>
    </Link>
  );
}
